import { ArrowUpDown } from 'lucide-react';

export const SortableHeader = ({
  column,
  title,
}: {
  column: any;
  title: string;
}) => (
  <button
    type="button"
    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
    className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors group"
  >
    {title}
    <ArrowUpDown className="h-3 w-3 opacity-40 group-hover:opacity-100 transition-opacity" />
  </button>
);
